import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import { TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING } from 'helper/constants';

const RadioList = ({
  LIST = TYPE_OF_OFFER_AND_DEMAND_TAB_HEADING,
  activeTab,
  handleTabChange,
}) => {
  return (
    <div className="d-flex align-items-center ">
      <form className="bg-check-row d-flex me-4 mb-1">
        {Object.values(LIST).map((tab) => (
          <FormGroup
            key={tab}
            className="bg-check me-1 d-inline-flex align-items-center mb-0"
            check
          >
            <Label htmlFor={tab} className="font-inter fw-medium" check>
              <Input
                type="radio"
                name="offerType"
                className="small"
                value={tab}
                checked={activeTab === tab}
                onChange={handleTabChange}
              />
              {tab}
            </Label>
          </FormGroup>
        ))}
      </form>
    </div>
  );
};

export default RadioList;
